import styled from 'styled-components'

// Layout for the redesigned company-scoped "Add Order" page. A single white
// card split into bordered sections, mirroring the Company Add Order design.
const CompanyAddOrderWrapper = styled.div`
  .card {
    background: ${(props) => props.theme.tokens.surface};
    border-radius: 8px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
    max-width: 1080px;
  }

  .section {
    padding: 24px;
    border-bottom: 1px solid ${(props) => props.theme.tokens.borderSubtle};
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .section:last-child {
    border-bottom: none;
  }

  /* ---- header ---- */
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    flex-wrap: wrap;
  }

  .header-identity {
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 0;
  }

  .header-title-row {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
  }

  .header-title {
    font-size: 22px;
    font-weight: 600;
    color: ${(props) => props.theme.tokens.textPrimary};
  }

  .header-meta {
    font-size: 13px;
    color: ${(props) => props.theme.tokens.textMuted};
  }

  .header-meta .num {
    color: ${(props) => props.theme.tokens.textPrimary};
    font-variant-numeric: tabular-nums;
  }

  /* ---- field grid ---- */
  .field-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 24px;
  }

  @media (max-width: 720px) {
    .field-grid {
      grid-template-columns: 1fr;
    }
  }

  .field {
    display: flex;
    flex-direction: column;
    gap: 8px;
    min-width: 0;
  }

  .field-label {
    font-size: 14px;
    font-weight: 600;
    color: ${(props) => props.theme.tokens.textPrimary};
  }

  .section-title {
    font-size: 16px;
    font-weight: 600;
    color: ${(props) => props.theme.tokens.textPrimary};
  }

  /* ---- radio dot rows (delivery / payment) ---- */
  .option-row-group {
    display: flex;
    gap: 28px;
    flex-wrap: wrap;
  }

  .option-row {
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    user-select: none;
    font-size: 14px;
    color: ${(props) => props.theme.tokens.textPrimary};
  }

  .dot {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    box-sizing: border-box;
    background: ${(props) => props.theme.tokens.surface};
    border: 1px solid ${(props) => props.theme.tokens.borderInput};
    flex-shrink: 0;
    transition: border 0.15s;
  }

  .dot--on {
    border: 5px solid ${(props) => props.theme.tokens.accentAlt};
  }

  /* ---- shipping address block ---- */
  .delivery-detail {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .delivery-actions {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
  }

  .delivery-actions .field-label {
    margin-right: 4px;
  }

  .note-line {
    font-size: 13px;
    color: ${(props) => props.theme.tokens.textMuted};
  }

  /* ---- shipping address cards ---- */
  .addr-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .addr-card {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 12px 16px;
    border: 1px solid ${(props) => props.theme.tokens.borderSubtle};
    background: ${(props) => props.theme.tokens.surface};
    border-radius: 8px;
    cursor: pointer;
    user-select: none;
    transition: border-color 0.15s, background 0.15s;
  }

  .addr-card--on {
    border-color: ${(props) => props.theme.tokens.accentAlt};
    background: ${(props) => props.theme.tokens.highlightInfo};
  }

  .addr-body {
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
    flex: 1;
  }

  .addr-name {
    font-size: 14px;
    font-weight: 500;
    color: ${(props) => props.theme.tokens.textPrimary};
  }

  .addr-detail {
    font-size: 13px;
    color: ${(props) => props.theme.tokens.textSecondary};
  }

  .addr-phone {
    font-size: 12px;
    color: ${(props) => props.theme.tokens.textMuted};
  }

  .addr-edit {
    font-size: 13px;
    flex-shrink: 0;
  }

  /* ---- footer ---- */
  .footer {
    padding: 20px 24px;
    display: flex;
    align-items: center;
    gap: 16px;
    flex-wrap: wrap;
  }

  .cancel-link {
    font-size: 14px;
    color: ${(props) => props.theme.tokens.textMuted};
  }
`

export default CompanyAddOrderWrapper
